const tech_img = require("../../assets/img/tutorials/mercamadrid/tech.png");
const secondary_tech_img = require("../../assets/img/tutorials/mercamadrid/secondary-tech.png");
const func_img = require("../../assets/img/tutorials/mercamadrid/func.png");
const secondary_func_img = require("../../assets/img/tutorials/mercamadrid/secondary-func.png");

export const MercamadridSteps = [
  {
    name: "Mercamadrid",
    title: "Descripción funcional",
    description: (
      <span>
        <p>
          El gemelo digital de <b>Mercamadrid</b> proporciona una visión en
          tiempo real sobre el funcionamiento del mercado mayorista de
          alimentos. Utilizando datos de sensores de tráfico simulados en los
          alrededores del recinto, se detectan retenciones y se optimiza la
          gestión del tráfico para garantizar un flujo eficiente de vehículos de
          carga.
        </p>
        <p>
          Además, se monitorizan las cámaras frigoríficas para detectar
          anomalías en su funcionamiento y se activa un sistema de alertas ante
          cualquier irregularidad, asegurando la integridad de los productos
          perecederos almacenados.
        </p>
        <p>
          Se realiza una monitorización de vehículos dentro del recinto para
          generar índices de congestión internos, permitiendo identificar áreas
          de mejora en la logística interna y optimizar los flujos de trabajo.
        </p>
        <p>
          Mediante técnicas de simulación y predicción, se anticipan y detectan
          potenciales problemas en el funcionamiento del recinto, asegurando una
          operación continua y eficiente.
        </p>
      </span>
    ),
    secondarydescription: (
      <span>
        <p>Área de Gobierno de Economía, Innovación y Empleo</p>
        <p>Área de Gobierno de Medio Ambiente y Movilidad</p>
        <p>Área de Gobierno de Seguridad y Emergencias</p>
      </span>
    ),
    mainimage: <img src={func_img} alt="main_func" />,
    secondaryimage: <img src={secondary_func_img} alt="sec_func" />,
  },
  {
    name: "Mercamadrid",
    title: "Descripción técnica",
    description: (
      <div>
        <span>
          Integraciones técnicas
          <ul>
            <li>
              <b>Modelos BIM de las naves</b>: Permiten una visualización
              detallada de la infraestructura y facilitan la gestión de
              mantenimiento y operaciones.
            </li>
            <li>
              <b>Cartografía 2D y 3D del recinto</b>: Proporciona una
              representación precisa del entorno, facilitando la planificación
              logística y la gestión del tráfico interno.
            </li>
            <li>
              Aplicación de algoritmos de{" "}
              <b>simulación y predicción avanzada</b>: Permiten anticipar y
              mitigar potenciales problemas en la operación del recinto,
              optimizando los procesos logísticos y de seguridad.
            </li>
          </ul>
        </span>
        <span>
          Origen de Datos
          <ul>
            <li>
              <b>Datos de sensores de tráfico simulados</b> en los alrededores
              del recinto, proporcionando información en tiempo real sobre el
              flujo vehicular y detectando retenciones para una gestión
              eficiente del tráfico.
            </li>
            <li>
              <b>Información de cámaras frigoríficas y vehículos</b> dentro del
              recinto, monitorizando su funcionamiento y generando alertas ante
              cualquier anomalía para garantizar la calidad de los productos.
            </li>
            <li>
              <b>Recorridos de vehículos de transporte de mercancías</b>, que se
              utilizan para analizar los flujos logísticos internos y mejorar la
              eficiencia de la distribución.
            </li>
          </ul>
        </span>
      </div>
    ),
    mainimage: <img src={tech_img} alt="main_tech" />,
    secondaryimage: <img src={secondary_tech_img} alt="sec_tech" />,
  },
];
